import React, { useEffect, useState } from "react";
import axios from 'axios';
import { APIPost } from "../API";
import { DownloadFiles } from "./DownloadFiles";
import DropLoad from "./DropLoad";
import { CollapsibleContainer } from "./CollapsibleContainer";
import { T } from "../traks";
import { AlertModal } from "./Modals";
import { Loading } from "./Loading";
import { RenderIf } from "../helpers/RenderIf";

const UploadAndDownload = ({
	setFiles,
	files,
	whistle,
	screenName,
	updateWhistle,
}) => {
	const accessId = whistle["whistle_access_id"] || null
	const accessType = whistle.access[0].type || null
	const whistleId = whistle.id
	const [downloadableFiles, setDownloadableFiles] = useState([])
	const resource = "whistles/" + whistleId + "/files"
	const [alertType, setAlertType] = useState({ type: "", text: "" })
	const [showAlert, setShowAlert] = useState(false)
	const [showLoading, setShowLoading] = useState(false)


	useEffect(() => {
		setDownloadableFiles(whistle.files || [])
	}, [whistle])

	const downloadFile = (file) => {
		setShowLoading(true)
		APIPost(resource, { "file_name": file.id, action: "get_download_url", access_id: accessId }).then(res => {
			fetch(res.data.presigned_url).then(response => response.blob().then(blob => {
				setShowLoading(false)
				const url = window.URL.createObjectURL(new Blob([blob]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", file.name);
				document.body.appendChild(link);
				link.click();
				link.parentNode.removeChild(link);
			}))
		}).catch(err => {
			setShowLoading(false)
			setAlertType({ type: "error", text: err.response.data })
			setShowAlert(true)
		})
	}

	const removeFile = (file) => {
		setShowLoading(true)
		APIPost(resource, { file: file, action: "delete_file", access_id: accessId }).then(res => {
			setShowLoading(false)
			setDownloadableFiles(downloadableFiles.filter(f => f.id !== file.id))
		}).catch(err => {
			setShowLoading(false)
			setAlertType({ type: "error", text: err.response.data })
			setShowAlert(true)
		})
	}


	const uploadFiles = (files) => {
		setShowLoading(true)
		const filesInfo = files.map(({ file, ...f }) => f)
		APIPost("whistles/" + whistleId + "/files", { files: filesInfo, action: "get_upload_url", access_id: accessId }).then(res => {
			const preSignedUrls = res.data.presigned_urls
			const promises = preSignedUrls.map((url, index) => {
				const file = files[index]
				const headers = { "Content-Type": file.type }
				headers["x-amz-meta-accessid"] = accessId
				headers["x-amz-meta-screenname"] = screenName
				headers["x-amz-meta-filename"] = file.name
				return axios.put(url, file.file, { headers }).then(res => {
					const logBody = {
						access_id: accessId,
						agent: screenName,
						log_action: "uploaded_files",
						action: "create_log",
						file_name: file.name,
						notify: false
					}
					APIPost(`whistles/${whistleId}/log`, logBody).then(res =>
						console.log(res)
					).catch(err =>
						console.log(err)
					)
				}).catch(err => console.log(err))
			})
			const timeoutPromise = new Promise((resolve, reject) => {
				setTimeout(() => reject('Timeout'), 5000);
			});
			Promise.race([Promise.all(promises), timeoutPromise])
				.then(() => {
					setShowLoading(false)
					updateWhistle()
					setFiles([])
				}).catch(err => {
					setShowLoading(false)
					setAlertType({ type: "error", text: "An error has happened" })
					setShowAlert(true)
				})
		}).catch(err => {
			setShowLoading(false)
			setAlertType({ type: "error", text: err.response.data })
			setShowAlert(true)
		})
	}

	return (<>
		<CollapsibleContainer>
			<div>
				<div className="fw_700">
					<T>Attached files</T>
				</div>
				<div>
					<T>All files beloning to the entry</T>:
				</div>

			</div>
			<div>
				<div className="mb-5">
					<DownloadFiles
						files={downloadableFiles}
						removeFile={removeFile}
						screenName={screenName}
						downloadFile={downloadFile}
					/>
				</div>
				<RenderIf condition={accessType && accessType !== "link"}>
					<div>
						<DropLoad
							setFiles={setFiles}
							files={files}
							uploadFiles={uploadFiles}
						/>
					</div>
				</RenderIf>
			</div>
		</CollapsibleContainer>
		<AlertModal
			isShowing={showAlert}
			setIsShowing={setShowAlert}
			type={alertType.type}
			text={alertType.text}
		/>
		<Loading
			showLoading={showLoading}
			inFront
			overlay
		/>
	</>);
};

export default UploadAndDownload;
